import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("vt_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "es" : "en";
    localStorage.setItem("vt_lang", next);
    setLang(next);
  };
  return <LangContext.Provider value={{ lang, toggle }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
